import config from 'config'

export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

export const isExtensionInstalled = () => {
  return new Promise((resolve, reject) => {
    if (!isChrome) {
      resolve(false)
    }

    window.chrome.runtime.sendMessage(config.DRIFT_VIDEO_EXTENSION_ID, { message: 'ping' }, response => {
      if (response && response.res) {
        resolve(response.res === 'pong')
      } else {
        resolve(false)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/extension.js